import styles from './Footer.module.css';

interface FooterProps {
  label: string;
  count: number;
  unit: string;
}

/**
 * 제자 또는 사역팀 총 개수를 표시하는 Footer 컴포넌트
 */
export const Footer = ({ label, count, unit }: FooterProps) => {
  return (
    <div className={styles.footer}>
      {label}: {count}{unit}
    </div>
  );
};

